export class ITPUserDto {
    userId?: number = -1;
    email: string = "";
    name: string = "";
}